/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChannelOverview } from './ChannelOverview';
import {
    ChannelOverviewFromJSON,
    ChannelOverviewFromJSONTyped,
    ChannelOverviewToJSON,
    ChannelOverviewToJSONTyped,
} from './ChannelOverview';

/**
 * 
 * @export
 * @interface MarketingChannelOverviewItemData
 */
export interface MarketingChannelOverviewItemData {
    /**
     * 
     * @type {string}
     * @memberof MarketingChannelOverviewItemData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingChannelOverviewItemData
     */
    name?: string;
    /**
     * 
     * @type {ChannelOverview}
     * @memberof MarketingChannelOverviewItemData
     */
    overview?: ChannelOverview;
    /**
     * 
     * @type {MarketingChannelOverviewItemDataSourceTypeEnum}
     * @memberof MarketingChannelOverviewItemData
     */
    sourceType?: MarketingChannelOverviewItemDataSourceTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingChannelOverviewItemData
     */
    orderOnly?: boolean;
}


/**
 * @export
 */
export const MarketingChannelOverviewItemDataSourceTypeEnum = {
    Meta: 'Meta',
    Google: 'Google',
    Microsoft: 'Microsoft',
    Pinterest: 'Pinterest',
    TikTok: 'TikTok',
    Criteo: 'Criteo',
    Sklik: 'Sklik',
    Heureka: 'Heureka',
    Glami: 'Glami',
    Zbozi: 'Zbozi'
} as const;
export type MarketingChannelOverviewItemDataSourceTypeEnum = typeof MarketingChannelOverviewItemDataSourceTypeEnum[keyof typeof MarketingChannelOverviewItemDataSourceTypeEnum];


/**
 * Check if a given object implements the MarketingChannelOverviewItemData interface.
 */
export function instanceOfMarketingChannelOverviewItemData(value: object): value is MarketingChannelOverviewItemData {
    return true;
}

export function MarketingChannelOverviewItemDataFromJSON(json: any): MarketingChannelOverviewItemData {
    return MarketingChannelOverviewItemDataFromJSONTyped(json, false);
}

export function MarketingChannelOverviewItemDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingChannelOverviewItemData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'overview': json['overview'] == null ? undefined : ChannelOverviewFromJSON(json['overview']),
        'sourceType': json['sourceType'] === undefined ? undefined : json['sourceType'] === null ? null : json['sourceType'],
        'orderOnly': json['orderOnly'] == null ? undefined : json['orderOnly'],
    };
}

export function MarketingChannelOverviewItemDataToJSON(json: any): MarketingChannelOverviewItemData {
    return MarketingChannelOverviewItemDataToJSONTyped(json, false);
}

export function MarketingChannelOverviewItemDataToJSONTyped(value?: MarketingChannelOverviewItemData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'overview': ChannelOverviewToJSON(value['overview']),
        'sourceType': value['sourceType'],
        'orderOnly': value['orderOnly'],
    };
}

